import React, { useEffect, useState, useRef } from 'react';
import partnerPointDetail3 from '../../assets/images/partner/partner_point_detail_3.png';
import partnerPointDetailCategory3 from '../../assets/images/partner/partner_point_detail_category_3.png';

function PartnerPoint3() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05,
        rootMargin: '-50px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="w-full flex justify-center bg-[#340065] overflow-hidden min-h-[780px] md:min-h-[855px]">
      <div className="w-full mb-[100px] md:mb-[100px] pt-[80px] md:pt-[0px] flex flex-col-reverse md:flex-row items-center justify-between mx-4 md:mx-[60px] bg-[#FDF4FF] rounded-t-none rounded-b-[50px]">
        {/* 왼쪽 이미지 영역 */}
        <div
          className={`w-full pb-[40px] md:pb-[0px] md:w-1/2 flex justify-center md:justify-end items-center mb-[40px] md:mb-0 mt-[50px] md:mt-0 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="relative md:mr-[20px] w-[300px] md:w-[600px] h-[263px] md:h-[526px] flex justify-center md:justify-end items-center">
            <div className="w-full h-full flex justify-center md:justify-end">
              <img
                src={partnerPointDetail3}
                alt="폰피쉬 앱 화면"
                className="h-full object-contain drop-shadow-lg"
                style={{ width: 'auto' }}
              />
            </div>
          </div>
        </div>

        {/* 오른쪽 텍스트 영역 */}
        <div
          className={`w-full md:w-1/2 flex flex-col justify-center items-center md:items-start px-4 md:px-[120px] space-y-[16px] md:space-y-[60px] transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <img
            src={partnerPointDetailCategory3}
            alt="렌즈 업무 부담 NO"
            className="w-[232px] h-[63px] md:w-[272px] md:h-[80px] object-contain"
          />

          <h2 className="font-pretendard font-bold text-[24px] md:text-[40px] leading-[140%] text-black text-center md:text-left">
            렌즈 판매 운영,<br />부담 없이 폰피쉬와 간편하게
          </h2>

          <p className="font-pretendard font-normal text-[16px] md:text-[22px] leading-[180%] text-black text-center md:text-left">
            📦 렌즈 사입, 재고, 포장까지 폰피쉬 전담<br />
            📢 APP · SNS 기반 자동 마케팅으로 고객 유입<br />
            📞 고객 CS 응대 폰피쉬가 대신 처리<br />
            💳 자동 정산 시스템과 관리자 시스템 제공
          </p>
        </div>
      </div>
    </section>
  );
}

export default PartnerPoint3; 